import { useEffect } from "react";
import * as React from "react";
import { connect } from "react-redux";
import { IdErrorCore } from "../../constants/IdErrorCore";
import { IdStyles } from "../../less/IdStyles";
import { selectCoopInviteResult } from "../../selectors/selectCoopInfo";
import { actionCoopInfoClearInvitePlayerResponse } from "../cooperative/actionCoop";
import { mapCoopInvitePlayerError } from "../cooperative/mapCoopInvitePlayerError";
import { actionErrorResolveAllErrors } from "../errors/actionError";
import { Badge } from "../generic/badge/Badge";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { BaseButton } from "../generic/base-button/BaseButton";
import { IdButtonType } from "../generic/base-button/IdButtonType";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { PlayerProfilePersonalButtons } from "./PlayerProfilePersonalInfoButtons";
import { ProfilePicture } from "./ProfilePicture";
var _PlayerProfilePersonalInfo = function (_a) {
    var clearInviteResponse = _a.clearInviteResponse, inviteStatus = _a.inviteStatus, inviteStatusIsError = _a.inviteStatusIsError, playerIcon = _a.playerIcon, playerName = _a.playerName, playerLevel = _a.playerLevel, playerId = _a.playerId, resolveInviteError = _a.resolveInviteError, onProfilePictureClick = _a.onProfilePictureClick;
    useEffect(function () {
        return function () {
            if (inviteStatus) {
                if (inviteStatusIsError) {
                    resolveInviteError();
                }
                else {
                    clearInviteResponse();
                }
            }
        };
    });
    var Wrapper = playerId
        ? function (_a) {
            var children = _a.children;
            return (React.createElement("div", { className: IdStyles.PlayerProfileCoopBackground + " flex flex--guts w100 h100" }, children));
        }
        : function (_a) {
            var children = _a.children;
            return (React.createElement(BaseButton, { name: IdStyles.ButtonSecondary, styleId: IdButtonType.ButtonSquareExtraLarge, onClick: onProfilePictureClick }, children));
        };
    return (React.createElement("div", { className: "flex flex--top flex--centered" },
        React.createElement(Wrapper, null,
            React.createElement("div", { className: "player-profile__pic-container" },
                React.createElement(ProfilePicture, { profilePictureName: playerIcon, profilePictureSize: IdStyles.ProfilePictureLarge }),
                React.createElement(Badge, { position: IdBadgePosition.BottomLeft, className: "dialog-player-profile__xp-badge" },
                    React.createElement(Icon, { icon: IdIcon.XpIcn, styleId: IdStyles.IconMedium },
                        React.createElement("div", { className: "flex flex--guts h100" },
                            React.createElement(NumberFormat, { amount: playerLevel, className: IdStyles.TextSmallBoldSecondaryOutline })))))),
        React.createElement("div", { className: "flex flex--stacked player-profile__name-and-buttons" },
            React.createElement("div", { className: IdStyles.PlayerProfileTextBackground + " " + IdStyles.TextNormal + "  player-profile__text-container" }, playerName),
            React.createElement("div", { className: "flex" },
                React.createElement(PlayerProfilePersonalButtons, { playerId: playerId })),
            inviteStatus && (React.createElement("div", { className: "player-profile__invite-result" },
                React.createElement(TextLoca, { id: inviteStatus, className: inviteStatusIsError ? IdStyles.TextNegative : IdStyles.TextPositive }))))));
};
var mapState = function (state, props) {
    var coopInviteResult = selectCoopInviteResult(state, props.playerId);
    var inviteStatusIsError = coopInviteResult !== undefined &&
        Array.from(mapCoopInvitePlayerError.values()).some(function (elem) { return elem === coopInviteResult; });
    return {
        inviteStatus: coopInviteResult,
        inviteStatusIsError: inviteStatusIsError,
    };
};
var mapDispatch = function (dispatch) { return ({
    clearInviteResponse: function () { return dispatch(actionCoopInfoClearInvitePlayerResponse()); },
    onProfilePictureClick: function () { return dispatch(actionModalOpen(IdModal.PlayerProfilePictureSelection)); },
    resolveInviteError: function () {
        return dispatch(actionErrorResolveAllErrors(IdErrorCore.CoopInvitePlayerErrors));
    },
}); };
export var PlayerProfilePersonalInfo = connect(mapState, mapDispatch)(_PlayerProfilePersonalInfo);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/PlayerProfilePersonalInfo.tsx
// module id = 2879
// module chunks = 3